/**
 * Australian public holidays — 2026 & 2027.
 * Covers federal + every state/territory. Each entry is tagged with the states
 * it applies to so downstream code can filter (or show all with "ALL").
 *
 * Source: Fair Work Ombudsman public holiday tables + state gazettes.
 * Dates are ISO YYYY-MM-DD (local).
 */

export const AU_STATES = ["ALL", "NSW", "VIC", "QLD", "WA", "SA", "TAS", "ACT", "NT"];

export const AU_HOLIDAYS = [
  // ================= 2026 =================
  { date: "2026-01-01", name: "New Year's Day",         states: ["NSW", "VIC", "QLD", "WA", "SA", "TAS", "ACT", "NT"] },
  { date: "2026-01-26", name: "Australia Day",          states: ["NSW", "VIC", "QLD", "WA", "SA", "TAS", "ACT", "NT"] },
  { date: "2026-03-02", name: "Labour Day",             states: ["WA"] },
  { date: "2026-03-09", name: "Labour Day",             states: ["VIC"] },
  { date: "2026-03-09", name: "Eight Hours Day",        states: ["TAS"] },
  { date: "2026-03-09", name: "Adelaide Cup",           states: ["SA"] },
  { date: "2026-03-09", name: "Canberra Day",           states: ["ACT"] },
  { date: "2026-04-03", name: "Good Friday",            states: ["NSW", "VIC", "QLD", "WA", "SA", "TAS", "ACT", "NT"] },
  { date: "2026-04-04", name: "Easter Saturday",        states: ["NSW", "VIC", "QLD", "SA", "ACT", "NT"] },
  { date: "2026-04-05", name: "Easter Sunday",          states: ["NSW", "VIC", "QLD", "WA", "SA", "ACT"] },
  { date: "2026-04-06", name: "Easter Monday",          states: ["NSW", "VIC", "QLD", "WA", "SA", "TAS", "ACT", "NT"] },
  { date: "2026-04-25", name: "ANZAC Day",              states: ["NSW", "VIC", "QLD", "WA", "SA", "TAS", "ACT", "NT"] },
  { date: "2026-04-27", name: "ANZAC Day (substitute)", states: ["WA"] },
  { date: "2026-05-04", name: "Labour Day",             states: ["QLD"] },
  { date: "2026-05-04", name: "May Day",                states: ["NT"] },
  { date: "2026-05-25", name: "Reconciliation Day",     states: ["ACT"] },
  { date: "2026-06-01", name: "Western Australia Day",  states: ["WA"] },
  { date: "2026-06-08", name: "King's Birthday",        states: ["NSW", "VIC", "QLD", "SA", "TAS", "ACT", "NT"] },
  { date: "2026-08-03", name: "Bank Holiday",           states: ["NSW"] },
  { date: "2026-08-03", name: "Picnic Day",             states: ["NT"] },
  { date: "2026-08-12", name: "Royal Queensland Show",  states: ["QLD"] }, // Brisbane only
  { date: "2026-09-28", name: "King's Birthday",        states: ["WA"] },
  { date: "2026-10-02", name: "AFL Grand Final Friday", states: ["VIC"] },
  { date: "2026-10-05", name: "Labour Day",             states: ["NSW", "ACT", "SA"] },
  { date: "2026-11-02", name: "Recreation Day",         states: ["TAS"] }, // northern TAS
  { date: "2026-11-03", name: "Melbourne Cup",          states: ["VIC"] },
  { date: "2026-12-25", name: "Christmas Day",          states: ["NSW", "VIC", "QLD", "WA", "SA", "TAS", "ACT", "NT"] },
  { date: "2026-12-26", name: "Boxing Day",             states: ["NSW", "VIC", "QLD", "WA", "SA", "TAS", "ACT", "NT"] },
  { date: "2026-12-28", name: "Boxing Day (substitute)", states: ["NSW", "VIC", "QLD", "WA", "SA", "TAS", "ACT", "NT"] }, // 26 is Sat
  { date: "2026-12-26", name: "Proclamation Day",       states: ["SA"] },

  // ================= 2027 =================
  { date: "2027-01-01", name: "New Year's Day",         states: ["NSW", "VIC", "QLD", "WA", "SA", "TAS", "ACT", "NT"] },
  { date: "2027-01-26", name: "Australia Day",          states: ["NSW", "VIC", "QLD", "WA", "SA", "TAS", "ACT", "NT"] },
  { date: "2027-03-01", name: "Labour Day",             states: ["WA"] },
  { date: "2027-03-08", name: "Labour Day",             states: ["VIC"] },
  { date: "2027-03-08", name: "Eight Hours Day",        states: ["TAS"] },
  { date: "2027-03-08", name: "Adelaide Cup",           states: ["SA"] },
  { date: "2027-03-08", name: "Canberra Day",           states: ["ACT"] },
  { date: "2027-03-26", name: "Good Friday",            states: ["NSW", "VIC", "QLD", "WA", "SA", "TAS", "ACT", "NT"] },
  { date: "2027-03-27", name: "Easter Saturday",        states: ["NSW", "VIC", "QLD", "SA", "ACT", "NT"] },
  { date: "2027-03-28", name: "Easter Sunday",          states: ["NSW", "VIC", "QLD", "WA", "SA", "ACT"] },
  { date: "2027-03-29", name: "Easter Monday",          states: ["NSW", "VIC", "QLD", "WA", "SA", "TAS", "ACT", "NT"] },
  { date: "2027-04-25", name: "ANZAC Day",              states: ["NSW", "VIC", "QLD", "WA", "SA", "TAS", "ACT", "NT"] },
  { date: "2027-04-26", name: "ANZAC Day (substitute)", states: ["NSW", "VIC", "QLD", "WA", "SA", "TAS", "ACT", "NT"] }, // 25 = Sun
  { date: "2027-05-03", name: "Labour Day",             states: ["QLD"] },
  { date: "2027-05-03", name: "May Day",                states: ["NT"] },
  { date: "2027-05-31", name: "Reconciliation Day",     states: ["ACT"] },
  { date: "2027-06-07", name: "Western Australia Day",  states: ["WA"] },
  { date: "2027-06-14", name: "King's Birthday",        states: ["NSW", "VIC", "QLD", "SA", "TAS", "ACT", "NT"] },
  { date: "2027-08-02", name: "Bank Holiday",           states: ["NSW"] },
  { date: "2027-08-02", name: "Picnic Day",             states: ["NT"] },
  { date: "2027-08-11", name: "Royal Queensland Show",  states: ["QLD"] },
  { date: "2027-09-27", name: "King's Birthday",        states: ["WA"] },
  { date: "2027-10-01", name: "AFL Grand Final Friday", states: ["VIC"] },
  { date: "2027-10-04", name: "Labour Day",             states: ["NSW", "ACT", "SA"] },
  { date: "2027-11-01", name: "Recreation Day",         states: ["TAS"] },
  { date: "2027-11-02", name: "Melbourne Cup",          states: ["VIC"] },
  { date: "2027-12-25", name: "Christmas Day",          states: ["NSW", "VIC", "QLD", "WA", "SA", "TAS", "ACT", "NT"] },
  { date: "2027-12-27", name: "Christmas Day (substitute)", states: ["NSW", "VIC", "QLD", "WA", "SA", "TAS", "ACT", "NT"] }, // 25 = Sat
  { date: "2027-12-26", name: "Boxing Day",             states: ["NSW", "VIC", "QLD", "WA", "SA", "TAS", "ACT", "NT"] },
  { date: "2027-12-28", name: "Boxing Day (substitute)", states: ["NSW", "VIC", "QLD", "WA", "SA", "TAS", "ACT", "NT"] }, // 26 = Sun
  { date: "2027-12-26", name: "Proclamation Day",       states: ["SA"] },
];

/**
 * Return holidays that fall in a given year+month (1-12), filtered by state.
 * @param {number} year
 * @param {number} month 1-12
 * @param {string} state one of AU_STATES (default "ALL")
 * @returns {Array<{date: string, day: number, names: string[]}>}
 */
export function holidaysInMonth(year, month, state = "ALL") {
  const y = String(year);
  const m = String(month).padStart(2, "0");
  const prefix = `${y}-${m}-`;
  const buckets = new Map(); // "YYYY-MM-DD" -> Set<name>
  for (const h of AU_HOLIDAYS) {
    if (!h.date.startsWith(prefix)) continue;
    if (state !== "ALL" && !h.states.includes(state)) continue;
    if (!buckets.has(h.date)) buckets.set(h.date, new Set());
    buckets.get(h.date).add(h.name);
  }
  return Array.from(buckets.entries())
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([date, nameSet]) => ({
      date,
      day: parseInt(date.slice(8, 10), 10),
      names: Array.from(nameSet),
    }));
}

const STORAGE_KEY = "hh-au-state";

export function getSavedState() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return AU_STATES.includes(v) ? v : "ALL";
  } catch (err) {
    // localStorage can be blocked in private browsing / hardened setups.
    // Non-fatal — fall back to "ALL" filter.
    console.debug("auHolidays getSavedState failed:", err);
    return "ALL";
  }
}

export function saveState(state) {
  if (!AU_STATES.includes(state)) return;
  try {
    localStorage.setItem(STORAGE_KEY, state);
  } catch (err) {
    // Non-fatal — private-mode storage denial. State will re-persist next visit.
    console.debug("auHolidays saveState failed:", err);
  }
}
